import { Text } from '@user-portal/wikr-components';
import { Trans, useTranslation } from 'react-i18next';

import { Button } from 'components/library';

import * as S from './styled';

import { IDiscountOfferProps } from './types';

const DiscountOffer = ({
  badgeText,
  badgePercent,
  badgeBackgroundColor,
  oldPrice,
  period,
  isNewOffer = false,
  currencySign,
  price,
  mb,
  onSubmitDiscount,
}: IDiscountOfferProps) => {
  const { t } = useTranslation();

  return (
    <S.Container $mb={mb}>
      <S.Badge $backgroundColor={badgeBackgroundColor}>
        <Text color="on-primary" medium center>
          {t(badgeText, { percent: badgePercent })}
        </Text>
      </S.Badge>
      <S.Details $paddingTop={20} $paddingX={16} $paddingBottom={16} $backgroundColor="surface-secondary">
        <Text type="small-button" center mb={20}>
          {t('subscription.cancellation.specialOffer.namePeriodICU', { period })}
        </Text>
        {oldPrice && (
          <S.CrossedText type="large-text" medium color="text-secondary" center mb={8}>
            <Trans
              i18nKey="subscription.cancellation.specialOffer.oldPricePeriodCrossed"
              values={{ currencySign, price: oldPrice, period }}
            />
          </S.CrossedText>
        )}
        <Text type="h2" medium center mb={isNewOffer ? 20 : 0}>
          <Trans
            i18nKey="subscription.cancellation.specialOffer.newPricePeriod"
            values={{ currencySign, price, period }}
            components={{ span: <S.Period /> }}
          />
        </Text>
        {isNewOffer && (
          <>
            <Text type="caption" center mb={20}>
              {t('subscription.cancellation.specialOffer.disclaimerNew')}
            </Text>
            {onSubmitDiscount && (
              <Button dataLocator="discountOfferChangePlanButton" onClick={onSubmitDiscount}>
                {t('subscription.cancellation.specialOffer.button')}
              </Button>
            )}
          </>
        )}
      </S.Details>
    </S.Container>
  );
};

export default DiscountOffer;
